// event listeners
const listeners = [];
/**
 * Add an event listener to an element.
 */
export function addEventListener(el, target, callback, options) {
    // check if options exist
    if (typeof options !== 'undefined') {
        const listenerOptions = {
            passive: false,
            once: false,
        };
        // check if once
        if (options.once) {
            listenerOptions.once = true;
        }
        // check if passive
        if (options.passive) {
            listenerOptions.passive = true;
        }
        // add an event listener
        el.addEventListener(target, callback, listenerOptions);
    }
    else {
        // add an event listener
        el.addEventListener(target, callback);
    }
    // generate an id for the listener
    const id = `${Math.random()}-${+new Date()}`;
    // add the listener to the stack
    listeners.push({
        id,
        el,
        target,
        callback,
    });
    // return data
    return {
        id,
        remove: removeEventListener.bind(this, id),
    };
}
/**
 * Remove an event listener from an element.
 */
export function removeEventListener(
/**
 * Id of the listener
 */
id) {
    // form a new array of listeners
    const newListeners = [];
    // go through all callbacks and search for the required one
    for (let i = 0, l = listeners.length; i < l; i++) {
        const data = listeners[i];
        // remove the callback
        if (data.id === id) {
            data.el.removeEventListener(data.target, data.callback);
        }
        else {
            // add the listener to the new array
            newListeners.push(data);
            continue;
        }
    }
}
